import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Switcher"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 3.75H13.5V6.75H10.5V3.75ZM3.75 3.75H6.75V6.75H3.75V3.75ZM17.25 3.75H20.25V6.75H17.25V3.75ZM10.5 10.5H13.5V13.5H10.5V10.5ZM3.75 10.5H6.75V13.5H3.75V10.5ZM17.25 10.5H20.25V13.5H17.25V10.5ZM10.5 17.25H13.5V20.25H10.5V17.25ZM3.75 17.25H6.75V20.25H3.75V17.25ZM17.25 17.25H20.25V20.25H17.25V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Switcher.vue"]]);
